import { useProvider } from "./context";
import { v4 as uuidv4 } from "uuid";
export default function Add({ color }) {
  const { dispatch } = useProvider();
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <button
        style={{
          background: color,
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          margin: "0.5rem 0",
          cursor: "pointer",
          border: "none"
        }}
        onClick={() => {
          dispatch({
            type: "ADD",
            payload: {
              id: uuidv4(),
              bgColor: color,
              desc: "",
              isPresent: true,
              date: Date()
            }
          });
        }}
      ></button>
    </div>
  );
}
